import o, { forwardRef as l } from "react";
import { VisuallyHidden as c } from "../../../VisuallyHidden/VisuallyHidden.js";
var i = Object.defineProperty,
  s = Object.defineProperties,
  u = Object.getOwnPropertyDescriptors,
  a = Object.getOwnPropertySymbols,
  b = Object.prototype.hasOwnProperty,
  f = Object.prototype.propertyIsEnumerable,
  n = (r, e, t) => e in r ? i(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t,
  d = (r, e) => {
    for (var t in e || (e = {})) b.call(e, t) && n(r, t, e[t]);
    if (a) for (var t of a(e)) f.call(e, t) && n(r, t, e[t]);
    return r;
  },
  m = (r, e) => s(r, u(e));
const p = l((r, e) => o.createElement("button", m(d({
  "data-ds-component": "DS-Dropdown-Button"
}, r), {
  ref: e,
  type: "button"
}), o.createElement(c, null, r.isOpen ? "Fechar" : "Mostrar", " op\xE7\xF5es"), r.children));
p.displayName = "Button";
export { p as Button };